<template>
 <div class="container">
  <el-form :model="questionForm" ref="questionForm">
   <section class="left">
    <div class="cell" @click.stop="handleSelect(cell)" :class="{disabled: pastList.includes(cell.questionCode), active: activeCode === cell.questionCode}" v-for="(cell, index) in formDesign" :key="index">{{((index + 1) >= 10) ? (index + 1) : `0${index + 1}`}}</div>
   </section>
   <section class="right">
    <div v-for="(cell, index) in formDesign" :key="index">
     <div class="cell" v-show="activeCode === cell.questionCode">
      <Library :disabled="!pastList.includes(cell.questionCode) || (pastList.includes(cell.questionCode) && activeCode != cell.questionCode)" :itemData="cell" :qForm="questionForm" />
     </div>
     <div class="btn" v-show="activeCode === cell.questionCode">
      <el-button @click.stop="handlePre" :disabled="$$(realResultList, 'length') > 0 || (index === 0 && recordList.length === 1)" type="primary" plain size="small" icon="el-icon-arrow-left">上一题</el-button>
      <el-button @click.stop="handleNextLogic(cell, index + 1)" type="primary" plain size="small">下一题<i class="el-icon-arrow-right el-icon--right"></i></el-button>
     </div>
    </div>
   </section>
  </el-form>
 </div>
</template>

<script>
import Library from './Library';

export default {
 data() {
  return {
   questionForm: {},
   activeCode: '',
   pastList: [],
   recordList: [],
   resultList: []
  }
 },
 watch:{
	'resultList':{
		handler(val){
			this.$emit('updateResult',{
				resultList:val,
				questions:this.questionForm
			})
		},
		deep:true
	} ,
	realResultList: {
		handler(val) {
//   if(this.formDesign.length < 1 && this.realResultList?.length < 1) return;
// 	if(this.realResultList && this.realResultList.length > 0) {
// 		for(const [index, item] of this.realResultList.entries()) {
// 			if(item.operateType === 'show') {
// 				this.pastList.push(item.questionCode);
// 			}
// 			this.recordList.push(item);
// 			this.resultList.push(item);
// 			this.$set(this.questionForm, item.questionCode, item.questionType == 2 ? (item.defaultValue ? item.defaultValue : []) : (item.defaultValue ? item.defaultValue : ''));
// 			this.handleNextLogic2(item, index);
// 			this.activeCode = this.pastList[0];
// 		}
// 	} else {
// 		this.activeCode = this.formDesign[0]['questionCode'];
// 		this.pastList = [this.formDesign[0]['questionCode']];
// 		this.recordList.push(this.formDesign[0]);
// 		for(const item of this.formDesign) {
// 			this.$set(this.questionForm, item.questionCode, item.questionType == 2 ? (item.defaultValue ? item.defaultValue : []) : (item.defaultValue ? item.defaultValue : ''));
// 		}
// 	}	
		},
		deep: true,
		immediate:true
	}
 },
 methods: {
  handleNextLogic(data, index) {
   if(data.isRequired == '1' && (!this.questionForm[data.questionCode] || this.questionForm[data.questionCode]?.length == 0)) {
    this.$message.error('该题为必答题');
    return;
   }
   if(data.ruleList.length === 0) {
    if(index >= this.formDesign.length) {
     this.$message.error('没有下一题了');
	 if(this.resultList.length == 0) {
		  this.$set(data, 'toCode', 'end');
		  this.resultList.push(data);
	 }
	 if(this.resultList.length > 0 && this.resultList[this.resultList.length - 1]['questionCode'] != data['questionCode']) {
		 this.$set(data, 'toCode', 'end');
		 this.resultList.push(data);
	 }
    } else {
     this.$set(data, 'toCode', this.formDesign[index]['questionCode']);
     this.handleNext(data);
    }
   } else {
    let next_count = 0;
    for(const item of data.ruleList) {
     if(item.ruleCode) {
      item.ruleCode = this.isString(item.ruleCode) ? JSON.parse(item.ruleCode) : item.ruleCode;
      let logic = [];
      for(const _item of item.ruleCode.list) {
       logic.push(`('${this.questionForm[_item.sourceCode]}' ${_item.condition} '${_item.option}')`);
      }
      if(data.questionType == '3' || eval(logic.toString().replace(',', item.ruleCode?.and_or ? ` ${item.ruleCode?.and_or} ` : ''))) {
       this.$set(data, 'toCode', item['toCode'])
       this.handleNext(data);
      } else {
       next_count++;
      }
     }
    }
    if(next_count === data.ruleList.length) {
     if(index >= this.formDesign.length) {
      this.$message.error('没有下一题了');
	  if(this.resultList.length > 0 && this.resultList[this.resultList.length - 1]['questionCode'] != data['questionCode']) {
		 this.$set(data, 'toCode', 'end');
		 this.resultList.push(data);
	 }
     } else {
      this.$set(data, 'toCode', this.formDesign[index]['questionCode'])
      this.handleNext(data);
     }
    }
   }
  },
  handleNext(data) {
   if(data.toCode === 'end') {
    this.$message.error('没有下一题了');
	if(this.resultList.length > 0 && this.resultList[this.resultList.length - 1]['questionCode'] != data['questionCode']) {
		 this.resultList.push(data);
	 }
   } else {
    this.activeCode = data.toCode;
    this.pastList.push(data.toCode);
    this.resultList.push(data);
    if(this.recordList[this.recordList.length - 1]['questionCode'] != data['questionCode']) {
     this.recordList.push(data);
    }
   }
  },
  handlePre() {
   if(this.recordList.length === 1) {
    this.activeCode = this.recordList[this.recordList.length - 1]['questionCode'];
    return;
   }
   this.recordList.splice(this.recordList.length - 1, 1);
   this.activeCode = this.recordList[this.recordList.length - 1]['toCode'];
  },
  handleSelect(item) {
   if(!this.pastList.includes(item.questionCode)) {
    return;
   }
   this.activeCode = item.questionCode;
  },
  isString(str){
   if(Object.prototype.toString.call(str) === "[object String]"){
    return true;
   }else{
    return false;
   }
  },
  handleNextLogic2(data, index) {
	if(data.ruleList.length === 0) {
		if(index >= this.realResultList.length) {
			this.$set(data, 'toCode', 'end');
		} else {
			this.$set(data, 'toCode', this.realResultList[index]['questionCode']);
		}
	} else {
		let next_count = 0;
		for(const item of data.ruleList) {
			if(item.ruleCode) {
				item.ruleCode = this.isString(item.ruleCode) ? JSON.parse(item.ruleCode) : item.ruleCode;
				let logic = [];
				for(const _item of item.ruleCode.list) {
					logic.push(`('${this.questionForm[_item.sourceCode]}' ${_item.condition} '${_item.option}')`);
				}
				if(data.questionType == '3' || eval(logic.toString().replace(',', item.ruleCode?.and_or ? ` ${item.ruleCode?.and_or} ` : ''))) {
					this.$set(data, 'toCode', item['toCode'])
				} else {
					next_count++;
				}
			}
		}
		if(next_count === data.ruleList.length) {
			if(index >= this.realResultList.length) {
				this.$set(data, 'toCode', 'end');
			} else {
				this.$set(data, 'toCode', this.realResultList[index]['questionCode'])
			}
		}
	}
},
 },

 created() {
	 if(this.formDesign.length < 1 && this.realResultList?.length < 1) return;
	if(this.realResultList && this.realResultList.length > 0) {
		for(const [index, item] of this.formDesign.entries()) {
			if(item.operateType === 'show') {
				this.pastList.push(item.questionCode);
			}
			this.recordList.push(item);
			this.resultList.push(item);
			this.$set(this.questionForm, item.questionCode, item.questionType == 2 ? (item.defaultValue ? item.defaultValue : []) : (item.defaultValue ? item.defaultValue : ''));
			this.handleNextLogic2(item, index);
			this.activeCode = this.pastList[0];
		}
	} else {
		this.activeCode = this.formDesign[0]['questionCode'];
		this.pastList = [this.formDesign[0]['questionCode']];
		this.recordList.push(this.formDesign[0]);
		for(const item of this.formDesign) {
			this.$set(this.questionForm, item.questionCode, item.questionType == 2 ? (item.defaultValue ? item.defaultValue : []) : (item.defaultValue ? item.defaultValue : ''));
		}
	}	
//   if(this.formDesign.length < 1 && this.realResultList?.length < 1) return;
// 	if(this.realResultList && this.realResultList.length > 0) {
// 		for(const [index, item] of this.realResultList.entries()) {
// 			if(item.operateType === 'show') {
// 				this.pastList.push(item.questionCode);
// 			}
// 			this.recordList.push(item);
// 			this.resultList.push(item);
// 			this.$set(this.questionForm, item.questionCode, item.questionType == 2 ? (item.defaultValue ? item.defaultValue : []) : (item.defaultValue ? item.defaultValue : ''));
// 			this.handleNextLogic2(item, index);
// 			this.activeCode = this.pastList[this.pastList.length - 1];
// 		}
// 	} else {
// 		this.activeCode = this.formDesign[0]['questionCode'];
// 		this.pastList = [this.formDesign[0]['questionCode']];
// 		this.recordList.push(this.formDesign[0]);
// 		for(const item of this.formDesign) {
// 			this.$set(this.questionForm, item.questionCode, item.questionType == 2 ? (item.defaultValue ? item.defaultValue : []) : (item.defaultValue ? item.defaultValue : ''));
// 		}
// 	}
 },
 components: {Library},
 props: ['formData', 'realResultList'],
 computed: {
  formDesign() {
   return this.realResultList?.length > 0 ? this.realResultList : this.formData.formDesign;
  },
 },
}
</script>

<style lang="scss" scoped>
.container {
 width: 100%;
 height: 100%;

 & .left {
  width: 200px;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  padding-right: 50px;

  & > .cell {
   width: 40px;
   height: 40px;
   margin: 12px;
   background: #F1F1F1;
   box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
   border-radius: 3px;
   border: 1px solid #D8D8D8;
   float: left;
   font-size: 20px;
   font-family: PingFangSC-Medium, PingFang SC;
   font-weight: 500;
   color: #DEDFDF;
   line-height: 40px;
   text-align: center;
   cursor: pointer;
   &.disabled {
    background: #F6F7F9;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
    border-radius: 3px;
    border: 1px solid #A6AAB8;
    color: #838A9D;
   }

   &.active {
    color: #838A9D;
    background: #F9FCFF;
    border-color: #337EFF;
    color: #337EFF;
   }
  }
 }

 & .right {
  width: calc(100% - 200px);
  height: 100%;
  display: inline-block;
  vertical-align: top;
  padding-top: 12px;

  & > div > .cell {
   width: 100%;
   border: solid 1px #C3C9D0;
   margin-bottom: 8px;
   border-radius: 4px;
   padding: 22px;
   cursor: pointer;
  }

  & > div  > .btn {
   width: 100%;
   height: 32px;
   text-align: right;
   margin-top: 80px;
   padding-right: 5px;
   text-align: center;

   & .el-button {
    margin: 0 30px;
   }
  }
 }

 
}
</style>